import { Alert, Text } from 'braid-design-system';
import React from 'react';
// @ts-ignore
import { SlideDown } from 'react-slidedown';

import { TextLink } from 'src/components';
import { useSite } from 'src/shared/hooks';
import type { Site, SuggestionType } from 'src/shared/types';

interface Props {
  tone?: 'promote' | 'info' | 'positive' | 'caution' | 'critical';
  suggestion: SuggestionType;
}

const ArticleSuggest = ({ suggestion, tone = 'info' }: Props) => {
  const site: Site = useSite();

  const generateMessage = (suggestionObj: SuggestionType) => {
    const { message, variables } = suggestionObj;

    if (variables === undefined) {
      return message;
    }

    const regex = /\%\S+/g;
    const textArray = message.split(' ');
    return textArray.map((a: string, index) => {
      if (regex.test(a)) {
        const obj = variables[a.replace(/\W+/g, '')];
        return (
          <TextLink
            key={index}
            target="_blank"
            tracking={obj.tracking}
            href={obj.site ? `${obj.site[site]}${obj.href}` : obj.href}
            product={obj.product || 'employer'}
          >
            {obj.label}
          </TextLink>
        );
      }
      return ` ${a} `;
    });
  };

  return (
    <SlideDown
      style={{
        height: 0,
        transitionProperty: 'none',
        transitionDuration: '0.3s',
        transitionTimingFunction: 'ease-in-out',
        overflowY: 'hidden',
      }}
    >
      <Alert tone={tone}>
        <Text>{generateMessage(suggestion)}.</Text>
      </Alert>
    </SlideDown>
  );
};

export default ArticleSuggest;
